/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const UserOldIcon = createIcon({
  displayName: "UserOldIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        d="M8 8C9.933 8 11.5 6.433 11.5 4.5C11.5 2.567 9.933 1 8 1C6.067 1 4.5 2.567 4.5 4.5C4.5 6.433 6.067 8 8 8Z"
        fill="currentColor"
      />
      <path
        d="M2.12501 11.8077C1.50217 10.8487 2.33427 9.75 3.47778 9.75H12.5218C13.6653 9.75 14.4974 10.8487 13.8746 11.8077C12.6267 13.7291 10.4616 15 7.9998 15C5.53796 15 3.37294 13.7291 2.12501 11.8077Z"
        fill="currentColor"
      />
    </g>
  )
});
